import React from 'react';
import { SparklesIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FeatureShowcase() {
  const {
    t
  } = useLanguage();
  return <section id="features" className="py-16 lg:py-24 bg-[#0a0e1a]" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-74">
          {/* Text Content */}
          <div data-id="element-75">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-76">
              {t('features.title')}
            </h2>

            <p className="text-gray-400 text-lg mb-8" data-id="element-77">
              {t('features.subtitle')}
            </p>

            <div className="space-y-6" data-id="element-78">
              <div className="flex gap-4" data-id="element-79">
                <div className="flex-shrink-0 w-12 h-12 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center" data-id="element-80">
                  <SparklesIcon className="w-6 h-6 text-[#ff6b35]" data-id="element-81" />
                </div>
                <div data-id="element-82">
                  <h3 className="text-white font-semibold mb-1" data-id="element-83">
                    {t('features.ai.title')}
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-84">
                    {t('features.ai.desc')}
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-85">
                <div className="flex-shrink-0 w-12 h-12 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center" data-id="element-86">
                  <TargetIcon className="w-6 h-6 text-[#ff6b35]" data-id="element-87" />
                </div>
                <div data-id="element-88">
                  <h3 className="text-white font-semibold mb-1" data-id="element-89">
                    {t('features.targeting.title')}
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-90">
                    {t('features.targeting.desc')}
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-91">
                <div className="flex-shrink-0 w-12 h-12 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center" data-id="element-92">
                  <TrendingUpIcon className="w-6 h-6 text-[#ff6b35]" data-id="element-93" />
                </div>
                <div data-id="element-94">
                  <h3 className="text-white font-semibold mb-1" data-id="element-95">
                    {t('features.forecast.title')}
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-96">
                    {t('features.forecast.desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Dashboard Preview - Hidden on tablet and mobile */}
          <div className="relative hidden lg:block" data-id="element-97">
            <div className="bg-gradient-to-br from-[#1a1f36] to-[#111827] rounded-2xl border border-white/10 p-6 shadow-2xl pointer-events-none select-none" data-id="element-98">
              {/* Header */}
              <div className="flex items-center justify-between mb-6" data-id="element-99">
                <div data-id="element-100">
                  <div className="text-white font-semibold" data-id="element-101">Lead-Übersicht</div>
                  <div className="text-gray-500 text-sm" data-id="element-102">Letzte 30 Tage</div>
                </div>
                <div className="flex gap-2" data-id="element-103">
                  <div className="px-3 py-1.5 bg-[#ff6b35] text-white text-xs rounded-md" data-id="element-104">
                    Alle
                  </div>
                  <div className="px-3 py-1.5 bg-white/5 text-gray-400 text-xs rounded-md" data-id="element-105">
                    Aktiv
                  </div>
                </div>
              </div>

              {/* Lead cards */}
              <div className="space-y-3" data-id="element-106">
                {[{
                name: 'Max Mustermann',
                company: 'TechCorp GmbH',
                score: 92,
                status: 'Heiß'
              }, {
                name: 'Anna Schmidt',
                company: 'Digital AG',
                score: 78,
                status: 'Warm'
              }, {
                name: 'Peter Weber',
                company: 'Startup Inc',
                score: 65,
                status: 'Warm'
              }].map((lead, i) => <div key={i} className="bg-[#0a0e1a] rounded-lg p-4 flex items-center gap-4" data-id="element-107">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#ff6b35] to-[#ff5722] flex items-center justify-center text-white font-semibold" data-id="element-108">
                      {lead.name.charAt(0)}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-109">
                      <div className="text-white font-medium truncate" data-id="element-110">
                        {lead.name}
                      </div>
                      <div className="text-gray-500 text-sm truncate" data-id="element-111">
                        {lead.company}
                      </div>
                    </div>
                    <div className="text-right" data-id="element-112">
                      <div className="text-[#ff6b35] font-semibold" data-id="element-113">
                        {lead.score}%
                      </div>
                      <div className={`text-xs ${lead.status === 'Heiß' ? 'text-red-400' : 'text-yellow-400'}`} data-id="element-114">
                        {lead.status}
                      </div>
                    </div>
                  </div>)}
              </div>

              {/* Action button - now static */}
              <div className="w-full mt-4 py-3 bg-[#ff6b35]/10 text-[#ff6b35] rounded-lg font-medium text-center" data-id="element-115">
                Alle Leads anzeigen →
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}